import { isDefined } from "@regrello/core-utils";
import type { SpectrumFieldVersionFields } from "@regrello/graphql-api";

import { getBasePartyTypeUnion, getPartyFullNameAndOrganization } from "../../../../../../utils/parties/partyUtils";
import type { CustomFieldFrontendSelectableOption } from "../types/CustomFieldFrontendSelectableOption";

export function extractAllowedValuesFromFieldVersionForFrontend(
  fieldVersion: Pick<SpectrumFieldVersionFields, "allowedValues" | "propertyType" | "id">,
): CustomFieldFrontendSelectableOption[] {
  return fieldVersion.allowedValues
    .map((allowedValue) => {
      switch (fieldVersion.propertyType.dataType) {
        case "STRING":
          if (allowedValue.stringValue == null) {
            return;
          }
          return {
            id: allowedValue.id,
            displayValue: allowedValue.displayStringValue ?? allowedValue.stringValue,
            value: allowedValue.stringValue,
          };
        case "PARTY_ID": {
          if (allowedValue.partyValue == null) {
            return;
          }
          const partyValue = getPartyFullNameAndOrganization(getBasePartyTypeUnion(allowedValue.partyValue));
          return {
            id: allowedValue.id,
            displayValue: partyValue,
            value: partyValue,
          };
        }
        default:
          throw new Error(
            `Received unhandled property data type: ${fieldVersion.propertyType.dataType} for fieldVersionId: ${fieldVersion.id}`,
          );
      }
    })
    .filter(isDefined);
}
